import { isDesktop, isTablet, isMobile } from "react-device-detect";
import { Link } from "common/src/router/compat";
import styled from "styled-components";
import PlayNowImg from "../../../abc/src/data/icons/play-now.svg";
import { ReactComponent as DoubleArrowsRight } from "../assets/icon-component/double-arrows-right.svg";
import { ReactComponent as DoubleArrowsLeft } from "../assets/icon-component/double-arrows-left.svg";

/* export const StyledGameLink = styled(Link)`
  opacity: 0.6;
  pointer-events: none;
  cursor: not-allowed;
  &:after {
    content: 'maintenance';
    position: relative;
    display: block;
    background: white;
    width: 100%;
    text-align: center;
    top: -20%;
    height: 0;
    color: white;
    font-weight: bolder;
    font-size: 12px;
    text-transform: uppercase;
  }
`;
 */

export const StyledProviderLogo = styled.section`
  margin: var(--styledProviderLogoMargin);
  max-width: var(--styledProviderLogoMaxWidth);
  border-bottom: var(--styledProviderLogoBorderBottom);
  background-color: ${({ background }) => background && "var(--footerBubleBG)"};
  border-radius: ${({ background }) => background && "45px"};

  @media only screen and (max-width: 767px) {
    width: var(--styledProviderLogoWidthMobile);
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    width: 90%;
  }
  svg {
    fill: red;
    background-color: red;
  }
`;

export const GameProviderH3 = styled.h3`
  color: var(--gameProviderH3Color);
  font-family: var(--gameProviderH3FontFamily);
  font-size: var(--gameProviderH3FontSize);
  font-weight: var(--gameProviderH3FontWeight);
  padding: 30px;

  @media only screen and (max-width: 767px) {
    margin: 0 20px;
    line-height: 25px;
    font-size: 1.4rem;
  }
`;

export const GameProviderWrapper = styled.div`
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;

  @media (min-width: 768px) {
    justify-content: var(--gameProviderWrapperJustifyMd);
  }

  @media (max-width: 767px) {
    justify-content: var(--gameProviderWrapperJustifyMobile);
    padding-bottom: var(--gameProviderWrapperPaddingBottomMobile);
  }
`;

export const GameProviderCol = styled.div`
  position: var(--gameProviderColPosition);
  width: var(--gameProviderColWidth);
  flex-basis: var(--gameProviderColFlexBasis);
  flex-grow: var(--gameProviderColFlexGrow);
  max-width: var(--gameProviderColMaxWidth);
  padding: var(--gameProviderColPadding);

  @media (min-width: 576px) {
    flex: var(--gameProviderColFlexSm);
    max-width: var(--gameProviderColMaxWidthSm);
  }

  @media (min-width: 992px) {
    flex: var(--gameProviderColFlexLg);
    max-width: var(--gameProviderColMaxWidthLg);
  }

  /* @media (max-width: 767px) {
    .row {
      margin-left: 0px;
      margin-right: 0px;
    }
  }
  @media (min-width: 768px) and (max-width: 924px) {
    .row {
      margin-left: 0px;
      margin-right: 0px;
    }
  } */
`;

export const GameProviderExtend = styled.div`
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  justify-content: var(--gameProviderExtendJustify);
  margin-bottom: var(--gameProviderExtendMarginBottom);
  border-right: var(--gameProviderExtendBorderSide);
  border-left: var(--gameProviderExtendBorderSide);

  @media (min-width: 768px) {
    justify-content: var(--gameProviderExtendJustifyMd);
  }

  .extra-border {
    :first-child {
      border-left: none;
    }
    :last-child {
      border-right: var(--gameProviderExtendExtraBorderRight);

      @media (max-width: 767px) {
        border-right: none;
      }
      @media (min-width: 768px) and (max-width: 1024px) {
        border-right: none;
      }
    }

    border-left: ${!isMobile
      ? "var(--gameProviderExtendExtraBorderLeftDesktop)"
      : ""};
  }
  svg {
    fill: var(--newsText);
    width: 120px;
    height: 100px;
    margin: 20px;
    padding: 15px;
    transition: transform 0.4s;
    -webkit-transition: transform 0.4s;
    -moz-transition: transform 0.4s; /* Firefox */
    -ms-transition: transform 0.4s; /* Internet Explorer */
    -o-transition: transform 0.4s;
    animation-delay: 0s;
    animation-duration: 1.5s;
    animation-timing-function: ease-in-out;
    animation-name: ${({ test }) => (test ? "scaleAnimation" : "")};
    animation-fill-mode: forwards;
    box-shadow: ${({ test }) =>
      test ? "0 0 11px rgba(146, 146, 146, 0.2)" : ""};
    -webkit-box-shadow: ${({ test }) =>
      test ? "0 0 11px rgba(146, 146, 146, 0.2)" : ""};
    @keyframes scaleAnimation {
      0% {
        transform: scale(1);
        -webkit-transform: scale(1); /* Safari & Chrome */
        -moz-transform: scale(1); /* Firefox */
        -ms-transform: scale(1); /* Internet Explorer */
        -o-transform: scale(1);
      }
      50% {
        transform: scale(1.2);
        -webkit-transform: scale(1.2); /* Safari & Chrome */
        -moz-transform: scale(1.2); /* Firefox */
        -ms-transform: scale(1.2); /* Internet Explorer */
        -o-transform: scale(1.2);
      }
      100% {
        transform: scale(1);
        -webkit-transform: scale(1); /* Safari & Chrome */
        -moz-transform: scale(1); /* Firefox */
        -ms-transform: scale(1); /* Internet Explorer */
        -o-transform: scale(1);
      }
    }

    &:hover {
      cursor: pointer;
      border-radius: 5px;
      box-shadow: 0 0 11px rgba(146, 146, 146, 0.2);
      -webkit-appearance: none;
      appearance: none;
      -webkit-box-shadow: 0 0 11px rgba(146, 146, 146, 0.2); /* Safari & Chrome */
      -moz-box-shadow: 0 0 11px rgba(146, 146, 146, 0.2); /* Firefox */
      transform: scale(1.5);
      -webkit-transform: scale(1.5); /* Safari & Chrome */
      -moz-transform: scale(1.5); /* Firefox */
      -ms-transform: scale(1.5); /* Internet Explorer */
      -o-transform: scale(1.5);
      transition: transform 0.2s;
      -webkit-transition: transform 0.2s;
      -moz-transition: transform 0.2s; /* Firefox */
      -ms-transition: transform 0.2s; /* Internet Explorer */
      -o-transition: transform 0.2s;
      padding: 10px;
      filter: blur(0px);
    }
  }

  .customTable {
    width: 100%;
    background-color: #ffffff;
    /* border-collapse: collapse;
    border-width: 1px;
    border-color: #7ea8f8;
    border-style: solid; */
    color: #000000;
  }

  .customTable td,
  table.customTable {
    text-align: center;
    /* border-width: 1px;
    border-color: #7ea8f8;
    border-style: solid; */
    border-left: 1px solid;
    padding: 5px;
  }

  img {
    width: 120px;
    height: 100px;
    margin: var(--gameProviderExtendImgMargin);
    padding: 15px;
    transition: transform 0.4s;
    -webkit-transition: transform 0.4s;
    -moz-transition: transform 0.4s; /* Firefox */
    -ms-transition: transform 0.4s; /* Internet Explorer */
    -o-transition: transform 0.4s;
    animation-delay: 0s;
    animation-duration: 1.5s;
    animation-timing-function: ease-in-out;
    animation-name: ${({ test }) => (test ? "scaleAnimation" : "")};
    animation-fill-mode: forwards;
    box-shadow: ${({ test }) =>
      test ? "0 0 11px rgba(146, 146, 146, 0.2)" : ""};
    -webkit-box-shadow: ${({ test }) =>
      test ? "0 0 11px rgba(146, 146, 146, 0.2)" : ""};
    @keyframes scaleAnimation {
      0% {
        transform: scale(1);
        -webkit-transform: scale(1); /* Safari & Chrome */
        -moz-transform: scale(1); /* Firefox */
        -ms-transform: scale(1); /* Internet Explorer */
        -o-transform: scale(1);
      }
      50% {
        transform: scale(1.2);
        -webkit-transform: scale(1.2); /* Safari & Chrome */
        -moz-transform: scale(1.2); /* Firefox */
        -ms-transform: scale(1.2); /* Internet Explorer */
        -o-transform: scale(1.2);
      }
      100% {
        transform: scale(1);
        -webkit-transform: scale(1); /* Safari & Chrome */
        -moz-transform: scale(1); /* Firefox */
        -ms-transform: scale(1); /* Internet Explorer */
        -o-transform: scale(1);
      }
    }

    &:hover {
      cursor: pointer;
      border-radius: 5px;
      box-shadow: var(--gameProviderExtendImgHoverBoxShadow);
      -webkit-appearance: none;
      appearance: none;
      -webkit-box-shadow: var(--gameProviderExtendImgHoverBoxShadow);
      -moz-box-shadow: var(--gameProviderExtendImgHoverBoxShadow);
      transform: scale(1.5);
      -webkit-transform: scale(1.5); /* Safari & Chrome */
      -moz-transform: scale(1.5); /* Firefox */
      -ms-transform: scale(1.5); /* Internet Explorer */
      -o-transform: scale(1.5);
      transition: transform 0.2s;
      -webkit-transition: transform 0.2s;
      -moz-transition: transform 0.2s; /* Firefox */
      -ms-transition: transform 0.2s; /* Internet Explorer */
      -o-transition: transform 0.2s;
      padding: 10px;
      filter: blur(0px);
      background-color: var(--gameProviderExtendImgHoverBg);
      border-left: var(--gameProviderExtendImgHoverBorderLeft);
    }
  }

  @media only screen and (max-width: 767px) {
    width: 330px;
    margin: 0px auto;
    text-align: center;
    justify-content: space-between;

    svg {
      width: 70px;
      height: 40px;
      padding: 0;
    }
    img {
      width: 70px;
      height: 40px;
      padding: 0;
    }
  }
  @media (min-width: 768px) and (max-width: 924px) {
    width: 100%;
    justify-content: var(--gameProviderExtendJustifyTablet);
  }
`;

export const ProviderList = styled.div`
  fill: var(--newsText);
  width: 120px;
  height: 100px;
  margin: 20px;
  padding: 15px;
  transition: transform 0.4s;

  &:hover {
    cursor: pointer;
    border-radius: 5px;
    -webkit-box-shadow: 0 0 11px rgba(146, 146, 146, 0.2);
    -moz-box-shadow: 0 0 11px rgba(146, 146, 146, 0.2);
    box-shadow: 0 0 11px rgba(146, 146, 146, 0.2);
    transform: scale(1.5);
    transition: transform 0.2s;
    padding: 10px;
    filter: blur(0px);
  }

  @media (max-width: 568px) {
    width: 60px;
    height: 20px;
    padding: 0;
  }

  @media (min-width: 568px) and (max-width: 767px) {
    width: 70px;
    height: 20px;
    padding: 0;
  }
`;

export const LobbyWrapper = styled.div.attrs((props) => ({
  className:
    props.theme.skin === "abc" ||
    props.theme.skin === "yet" ||
    props.theme.skin === "fun"
      ? ""
      : "mb-5",
}))`
  svg {
    padding: ${({ gameLoader }) => gameLoader && "0px 20px"};
    max-width: 1600px;
  }
  padding-top: ${({ gamesCategory }) => gamesCategory && "5rem"};
  flex-direction: column;
  height: auto;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) =>
    theme.skin === "abc" ||
    theme.skin === "yet" ||
    theme.skin === "qbc" ||
    theme.skin === "bec"
      ? "var(--mainDescriptionABC)"
      : "var(--lobbybg)"};
  & > div {
    width: ${({ theme }) =>
      (theme.skin === "pub" || theme.skin === "cac" || theme.skin === "hyc") &&
      isMobile
        ? ""
        : "1600px"};
    height: auto;
    max-width: 100%;
    padding: ${isTablet ? "1rem" : "40px 0"};
    z-index: ${({ sportsbook }) => !sportsbook && "2"};

    @media (max-width: 768px) {
      padding: ${isMobile ? "0px 10px 10px 10px" : "10px 20px 0 20px"};
    }
  }

  /* .game-category {
    height: auto;
    max-width: 100%;
    margin-top: 0px;
    &-header {
      width: 100%;
      height: 67px;
    }
  } */

  .btn {
    font-size: 1rem;
    padding: ${({ theme }) =>
      theme.skin === "cac" || theme.skin === "hyc" ? "15px 20px" : "20px"};
    min-width: 170px;
  }
`;

export const GameCategory = styled.div`
  height: auto;
  max-width: 100%;
  margin-top: 0px;

  @media (max-width: 770px) {
    margin-top: 0px;
  }
`;

export const GameCategoryTitle = styled.h1`
  font-weight: 600;
  color: ${({ theme }) =>
    theme.skin === "pub"
      ? "#9A875D"
      : "var(--showall)"};
  text-transform: capitalize;
  font-size: 24px !important;
  top: ${({ category }) => (category ? "" : "-30px")};

  @media (max-width: 1024px) {
    font-size: 20px !important;
  }
`;

export const GameCategoryContent = styled.div`
  height: auto;
  max-width: 100%;
  margin-top: 0px;
  display: ${({ hide }) => (hide ? "none" : "")};
  margin-bottom: ${({ removeMargin }) => (removeMargin ? "4rem" : "")};
`;
export const EmptyCategoriy = styled.div`
  max-width: 100%;
  margin-top: 0px;
  padding: 100px 0;
  display: ${({ hide }) => (hide ? "none" : "")};
  text-align: center;
  div {
    font-weight: 800;
    font-size: 1rem;
    color: var(--newsText);
  }
  div:first-of-type {
    font-size: 1.4rem;
    padding-top: 1rem;
    color: var(--emptyCategoryColor);
    @media (max-width: 790px) {
      font-size: 1.2rem;
    }
  }
  svg {
    fill: var(--newsText);
    width: 100px;
    padding-top: 1rem;
  }
`;

export const GameCategoryHeader = styled.div`
  width: ${({ qbcSpecial }) => (qbcSpecial ? "50%" : "100%")};
  text-align: ${({ gameTheme, theme }) =>
    gameTheme ? "left" : theme.skin === "pub" ? "center" : ""};

  display: flex;
  justify-content: space-between;
  flex-direction: ${({ index }) => index && "row-reverse"};
  align-items: baseline;
  padding: ${isMobile && "10px 0"};
  flex-direction: ${({ qbcSpecial }) => (qbcSpecial ? "row-reverse" : "")};

  a {
    margin: ${({ qbcSpecial }) => (qbcSpecial ? "0 !important" : "")};
  }

  @media (max-width: 767px) {
    /* height: ${({ provider, theme }) =>
      provider ? "" : theme.skin === "abc" ? "25px" : ""}; */
    p {
      margin-bottom: ${({ theme }) => theme.skin === "abc" && "0"};
    }
  }
`;

export const CategoryTitle = styled.p`
  font-family: ${({ theme }) => theme.skin === "pub" && "Ancho"};
  font-size: ${({ theme }) => (theme.skin === "pub" ? "1.13rem" : "24px")};
  float: ${({ theme }) => theme.skin !== "pub" && "left"};
  font-weight: ${({ theme }) => (theme.skin === "pub" ? "300" : "600")};
  color: var(--showall);
  text-transform: capitalize;
  text-align: center;

  @media (max-width: 770px) {
    font-size: ${({ theme }) => (theme.skin === "abc" ? "16px" : "20px")};
  }
`;

export const ShowAllGames = styled.p`
  font-weight: 600;
  color: var(--showall);
  text-transform: capitalize;
  cursor: pointer;
  font-size: 15px;
  text-align: center;
  /* padding-top: ${({ theme }) => theme.skin === "pub" && "1rem"}; */

  @media (max-width: 770px) {
    font-size: 12px;
  }
`;

export const ShowAllArrow = styled.span`
  margin-left: 10px;
  font-size: 32px;
  font-weight: 400;
  vertical-align: bottom;
  position: relative;
  bottom: 3px;

  @media (max-width: 768px) {
    position: ${({ theme }) => theme.skin !== "qbc" && "static"};
  }
`;

export const GamesGriddy = styled.div.attrs((props) => ({
  className: props.remainder
    ? "grid-container-reverse"
    : props.opened
      ? "grid-container-opened"
      : "grid-container",
}))`
  .first,
  .eight {
    grid-area: ${({ racGameCategorie }) => racGameCategorie && "auto"};
  }
  & > a {
    /* filter: ${({ theme }) => theme.skin === "pub" && `grayscale(100%)`};
    -webkit-filter: ${({ theme }) =>
      theme.skin === "pub" && `grayscale(100%)`}; */
    display: block;
    box-sizing: border-box !important;
    padding: 0 !important;
    margin: 0 !important;
    background-color: transparent;
    background-size: 50px;
    background-position: center;
    background-repeat: no-repeat;

    &:hover {
      filter: ${({ theme }) => theme.skin === "pub" && `grayscale(100%)`};
      -webkit-filter: ${({ theme }) =>
        theme.skin === "pub" && `grayscale(100%)`};
    }
    source,
    img {
      max-width: 100%;
      width: 100%;
      height: 100%;
      /*object-fit: cover;*/
    }

    &.maintenance {
      opacity: 0.5;
      pointer-events: none;
      cursor: not-allowed;
      &:after {
        content: ${"'Maintenance'"};
        position: relative;
        display: block;
        background: white;
        width: 100%;
        text-align: center;
        top: -20%;
        height: 0;
        color: white;
        font-weight: bolder;
        font-size: 16px;
        text-transform: uppercase;
        text-shadow: #000 0px 2px 6px;
      }
    }
  }

  grid-template-columns: ${({ specialGame }) => specialGame && "100%"};
  a:first-child {
    border-top-left-radius: ${({ theme }) =>
      theme.skin === "fun" || theme.skin === "cac" || theme.skin === "hyc"
        ? "15px"
        : ""};
    picture,
    source,
    img {
      border-top-left-radius: ${({ theme }) =>
        theme.skin === "fun" || theme.skin === "cac" || theme.skin === "hyc"
          ? "15px"
          : ""};
    }
  }
  a:last-child,
  .bottom-left-corner {
    border-bottom-right-radius: ${({ theme }) =>
      theme.skin === "fun" || theme.skin === "cac" || theme.skin === "hyc"
        ? "15px"
        : ""};
    picture,
    source,
    img {
      border-bottom-right-radius: ${({ theme }) =>
        theme.skin === "fun" || theme.skin === "cac" || theme.skin === "hyc"
          ? "15px"
          : ""};
    }
  }
  .last-in-row {
    border-top-right-radius: ${({ theme }) =>
      theme.skin === "fun" || theme.skin === "cac" || theme.skin === "hyc"
        ? "15px"
        : ""};
    picture,
    source,
    img {
      border-top-right-radius: ${({ theme }) =>
        theme.skin === "fun" || theme.skin === "cac" || theme.skin === "hyc"
          ? "15px"
          : ""};
    }
  }
  .first-in-last-colon {
    border-bottom-left-radius: ${({ theme }) =>
      theme.skin === "fun" || theme.skin === "cac" || theme.skin === "hyc"
        ? "15px"
        : ""};
    picture,
    source,
    img {
      border-bottom-left-radius: ${({ theme }) =>
        theme.skin === "fun" || theme.skin === "cac" || theme.skin === "hyc"
          ? "15px"
          : ""};
    }
  }

  a > picture {
    transition: all 0.2s ease;
    /* object-fit: cover; */
    display: block;
    width: 100%;
    height: 100%;
    /* background: var(--brandcolor); */
    cursor: pointer;

    img {
      transition: all 0.2s ease;
      display: block;
      width: 100%;
      height: 100%;
      aspect-ratio: ${({ specialGame }) => !specialGame && "328 / 218"};
      cursor: pointer;
    }
    /* img:before {
      content: "We're sorry, the image below is broken :(";
      display: block;
      margin-bottom: 10px;
    } */

    &:hover {
      opacity: ${({ theme }) => theme.skin !== "pub" && `0.1`};
    }
  }
`;

export const StyleGameLink = styled(Link).attrs((props) => ({
  className:
    (props.maintentnece && " maintenance ") +
    (props.lastInRow && " last-in-row ") +
    (props.bottomLeftCorner && " first-in-last-colon ") +
    (props.bottomRightCorner && " bottom-left-corner "),
}))`
  p {
    display: none;
  }
  ${(props) => {
    if (
      (props.theme.skin === "abc" ||
        props.theme.skin === "yet" ||
        props.theme.skin === "fun" ||
        props.theme.skin === "cac" ||
        props.theme.skin === "hyc") &&
      isDesktop
    ) {
      return `
      :hover {
        p {
          display: inline;
        }
        color: transparent;
        width: 100%;
        height: 100%;
        display: block;
        box-sizing: border-box !important;
        padding: 0 !important;
        margin: 0 !important;
        background-image: url(${PlayNowImg});
        background-size: 100px;
        background-position: center;
        background-repeat: no-repeat;
        font-size: 1rem;
        font-weight: 800;
        cursor: pointer;
        text-align:center;
        background-color: ${
          props.theme.skin === "abc"
            ? "#940521"
            : props.theme.skin === "cac"
              ? "var(--playLive)"
              : props.theme.skin === "hyc"
                ? "var(--bgColorABC)"
                : "var(--brandcolor)"
        };
        color: #fff;
        }
      
      `;
    }
  }}
`;

export const HoverGamePar = styled.p`
  width: 304px;
  position: absolute;
  text-align: center;
  margin-left: -152px;
  margin-top: 30px;
  font-size: 1rem;
  font-weight: 700;
  color: #fff;

  @media (max-width: 1366px) {
    margin-top: 20px;
  }
`;

export const GameDetailWrapper = styled.div.attrs((props) => ({
  className: `${
    props.sb ? "" : "vh-100"
  } d-flex align-items-center justify-content-center`,
}))``;

export const GameSpinner = styled.div.attrs({
  className: "spinner-border",
})`
  color: var(--brandcolor);
`;

export const GameContent = styled.div.attrs({
  className: " d-flex",
})`
  /* max-height: ${({ extraHeight }) => !extraHeight && "100vh"}; */
  position: relative;
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-color: ${({ theme }) =>
    theme.skin === "cac" || theme.skin === "hyc" ? "transparent" : "black"};
  background-image: ${({ theme, img }) =>
    `url(//dui95pyok1n5r.cloudfront.net/${theme.skin}/backgrounds${
      theme.skin !== "abc" ? "-v2" : ""
    }/${img})`};
`;

export const StyledGameWrapper = styled.div`
  background-color: var(--gamebg);
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-bottom: ${isDesktop ? "1rem" : ""};

  .game-info {
    display: flex;
    color: var(--footerTextColor);
    text-align: center;

    h1,
    h2,
    h3,
    h4,
    h5 {
      color: var(--footerTextColor);
      text-align: center;
    }
  }
`;

export const StyledGameFlex = styled.div.attrs({
  className: "d-flex content-top justify-content-end",
})`
  color: #fff;
  width: 100%;
  margin: 130px auto 0 auto;
  text-align: center;
  height: ${({ theme }) =>
    theme.skin === "abc" || theme.skin === "yet" || theme.skin === "fun"
      ? "30px !important"
      : "20px !important"};
  width: ${({ pageWidth }) => pageWidth} !important;
`;

export const QuickDeposit = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  .btn {
    min-height: 60px;
  }
  .btn-first {
    text-transform: uppercase;
    padding: 20px;
    font-size: 1.5rem;
    font-weight: 900;
  }
`;

export const GameCommands = styled.div`
  ${(props) => {
    if (
      props.theme.skin === "abc" ||
      props.theme.skin === "yet" ||
      props.theme.skin === "fun"
    ) {
      return `
        background-color: var(--iconbulbABC);
        border-radius: 5px 5px 0 0;
      `;
    }
  }}
  svg {
    width: 30px;
    padding: ${({ theme }) =>
      theme.skin === "abc" || theme.skin === "yet" || theme.skin === "fun"
        ? "5px"
        : "0 0 10px 0"};
    cursor: pointer;
    path:nth-of-type(2) {
      fill: ${({ theme }) =>
        theme.skin === "abc" ? "var(--switchfill)" : "var(--switchfill)"};
      transition: all 0.2s ease;
      -webkit-transition: all 0.2s ease;
    }
  }
`;

export const GameFullscreanWrapper = styled.div`
  width: ${({ pageWidth }) => pageWidth};
  height: ${({ pageHeight }) => pageHeight};
  ${(props) => {
    if (props.mobile) {
      return `
      background: black;
      position: fixed;
      top:0;
      left:0;
      bottom:0;
      right:0;
      margin: 0;
      padding: 0;
      iframe {
        width: 100% !important;
        height: 100% !important;
      }
      `;
    } else if (props.fullscreen) {
      return `
      object-fit: contain;
      position: fixed !important;
      top: 0px !important;
      right: 0px !important;
      bottom: 0px !important;
      left: 0px !important;
      box-sizing: border-box !important;
      min-width: 0px !important;
      max-width: none !important;
      min-height: 0px !important;
      max-height: none !important;
      width: 100% !important;
      height: calc(100% - 21px) !important;
      transform: none !important;
      margin: 0px !important;
      `;
    } else {
      return `
        align-self: center;
        max-height: calc(100vh - 200px);`;
    }
  }}
`;

export const GamePanelSE = styled.div.attrs({
  id: "box",
})`
  display: flex;
  flex-direction: column;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1003;
  top: 0;
  left: 0;
  width: 70px;
  height: 100px;
  justify-content: space-around;
  align-items: center;
  position: fixed;

  img {
    max-width: 95%;
    height: 20px;
    max-height: 100%;
    width: auto;
  }

  &:hover {
    cursor: pointer;
  }
`;

export const GamePanelHeader = styled.button.attrs({
  id: "panelHeader",
})`
  width: 100%;
  text-align: center;
  //height: 10px;
  -webkit-filter: invert(100%);
  filter: invert(100%);
  border: none;

  img {
    width: 15px;
  }
`;

/* export const GamePanelHeader = styled.div`
  width: 10px;
  //height: 10px;
  -webkit-filter: invert(100%);
  filter: invert(100%);
`; */

export const StyledSELink = styled.a`
  background: white;
  margin: 1px;
  display: flex;
  padding: 3px;
  height: 100%;
`;

export const GameCasinoTimeWrapper = styled.div.attrs({
  className: "d-flex justify-content-center",
})`
  width: 100%;
  /* height: 50px; */
  //text-transform: uppercase;
  font-size: 12px;
  color: var(--footerh);
  padding: 0 30px;
  margin-top: 10px;
  div {
    display: flex;
    margin: 0 15px;
    svg {
      margin-left: 15px;
    }
  }
  .swe img {
    height: 30px;
    margin-left: 15px;
  }
`;

export const GameAlignCenter = styled.div.attrs((props) => ({
  className: props.swe ? "align-self-center ml-auto p-2" : "align-self-center",
}))`
  ${(props) => {
    if (props.swe) {
      return `
      img {
        height: 30px;
        margin-left: 15px;
      }
      `;
    }
  }}
`;

export const SidepanelButton = styled.div`
  position: relative;
  top: 0;
  left: calc(100% - 50px);
  text-align: right;
  float: right;
  width: 30px;
  padding: 0;

  :hover {
    cursor: pointer;
  }
`;

export const StyledDoubleArrowsLeft = styled(DoubleArrowsLeft)`
  fill: var(--acolor);
`;

export const StyledDoubleArrowsRight = styled(DoubleArrowsRight)`
  transform: rotate(180deg);
  fill: var(--acolor);
`;

export const FullPageOverlay = styled.div`
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 9999999;
  display: ${({ gameWindow }) => gameWindow && "flex"};
  align-items: ${({ gameWindow }) => gameWindow && "center"};
  justify-content: ${({ gameWindow }) => gameWindow && "center"};
`;

export const IngameDeposit = styled.div`
  background-color: var(--bgcolor);
  z-index: 400;
  width: auto;
  margin: auto;
  position: fixed;
  padding: ${isMobile ? "" : "0 20px 0 20px"};
  min-width: ${isMobile ? "90vw" : "600px"};
  overflow: ${isMobile ? "auto" : ""};
  height: ${({ isLandscape }) => isLandscape && isMobile && "280px"};
  max-height: ${isMobile ? "90vh" : ""};

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) =>
      theme.skin === "fun"
        ? "var(--thumbBG)"
        : theme.skin === "pub"
          ? "#9A875D"
          : theme.skin === "cac" || theme.skin === "hyc"
            ? "#AAA2A5"
            : "var(--footerTextColor)"};
    border-radius: 5px;
    border: 0px solid var(--scrollbarBG);
  }

  select {
    padding: ${isMobile && "0"};
  }

  button {
    /* height: 55px; */
  }

  svg {
    position: absolute;
    right: 0px;
    top: 0px;
    fill: var(--tabletext);
    cursor: pointer;
    z-index: 9;
    border: none;
    width: 25px;
    height: 25px;
  }

  input,
  select {
    height: ${isMobile && "40px"};
  }
  form {
    margin-bottom: ${isMobile && "0 !important"};
    margin-top: ${isMobile && "0 !important"};
  }

  @media (max-width: 880px) {
    width: initial;
  }
`;

export const SidePanelWrapper = styled.div`
  z-index: 100;
  background-color: ${({ theme }) =>
    theme.skin === "abc"
      ? "var(--mainDescriptionABC)"
      : theme.skin === "cac" || theme.skin === "hyc" || theme.skin === "bec"
        ? "var(--gamebg)"
        : "var(--sideMenu)"};

  /* -webkit-transition: 0.5s;
  -moz-transition: 0.5s;
  -o-transition: 0.5s;
  transition: 0.5s; */
  &-top,
  &-bottom {
    color: #fff;
    height: 100px;
    align-items: center;
  }

  width: ${({ isOpened }) => (isOpened ? "320px" : "0px")};
  position: ${({ isOpened }) => (isOpened ? "relative" : "")};
  display: ${({ isClosed }) => (isClosed ? "none" : "")};
  flex: ${({ isClosed }) => (isClosed ? "1" : "")};
  padding: ${({ theme }) =>
    (theme.skin === "cac" || theme.skin === "hyc" || theme.skin === "bec") &&
    "20px 20px 20px 0"};
  max-height: 100vh;

  table {
    table-layout: fixed;
    width: 100%;
    tr {
      height: 60px;
      border-bottom: "1px solid rgba(255, 255, 255, 0.13)";
      th {
        font-size: 0.7rem;
        color: #fff;

        font-weight: 600;
        .flag {
          margin-left: 10px;
        }
        a {
          text-align: center;
          text-decoration: none;
          color: #fff;
        }
        &.win {
          font-weight: 800;
          text-align: right;
          padding-right: 10px;
        }
        &:nth-child(1) {
          text-align: left;
        }
        &:nth-child(3) {
          width: 25%;
          text-align: center;
          font-weight: 900;
        }
        &:nth-child(2) {
          text-align: center;
        }
      }
    }
  }
`;

export const SidePanelDiv = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 30px;
  border-radius: ${({ theme }) =>
    (theme.skin === "cac" || theme.skin === "hyc" || theme.skin === "bec") &&
    "30px"};
  background-color: ${({ theme }) =>
    (theme.skin === "cac" ||
      theme.skin === "hyc" ||
      theme.skin === "hyc" ||
      theme.skin === "bec") &&
    "var(--sideMenu)"};
`;

export const SidePanelTop = styled.div.attrs({
  /* className: "mt-3", */
})`
  color: #fff;
  height: 200px;
  align-items: center;
  /* position: ${({ theme }) => theme.skin === "abc" && "absolute"}; */
  display: ${({ isClosed }) => (isClosed ? "none" : "")};

  .tab-winner {
    padding: 0.75rem 1.75rem 0.75rem 0.75rem;
    cursor: pointer;
  }
`;

export const SidePanelToogleSearch = styled.div.attrs({
  className: "align-self-center align-items-center",
})`
  padding: 40px 0;

  svg {
    vertical-align: bottom;
  }

  &:hover {
    cursor: pointer;
  }
`;

export const SidePanelSelect = styled.div.attrs({
  className: "col-5 flex-nowrap",
})`
  padding: 0 !important;
  margin-top: 0px;
  :hover {
    color: #fff;
  }
  display: ${({ hideonsearch }) => (hideonsearch ? "none" : "")};
`;

export const CustomSelect = styled.select.attrs({
  className: "custom-select",
})`
  font-weight: bold;
  color: #fff !important;
  padding: 0;
  font-size: 0.8rem;
  cursor: pointer;
  background-size: 15px;
  padding: 0 !important;
  width: ${({ theme }) =>
    theme.skin === "abc" || theme.skin === "yet" || theme.skin === "fun"
      ? "250px"
      : "180px !important"};
  text-transform: capitalize;
  option {
    background-color: ${({ theme }) =>
      theme.skin === "abc"
        ? "var(--bgColorABC)"
        : theme.skin === "fun"
          ? "var(--inputbgABC)"
          : "var(--customInputColor)"};
    color: ${({ theme }) =>
      theme.skin === "abc" ? "#0554B3" : "var(--acolor)"};
  }
`;

export const TabWinner = styled.div.attrs({
  className: "text-uppercase",
})`
  padding: 0.75rem 1.75rem 0.75rem 0.75rem;
  cursor: pointer;
`;

export const SidePanelTable = styled.div.attrs((props) => ({
  className: props.showAll ? "mt-5 overflow-auto" : "mt-3 overflow-hidden",
}))`
  position: relative;
  height: auto;
  scrollbar-width: thin;
  /* scrollbar-color: var(--thumbBG) var(--scrollbarBG); */

  table {
    display: inline-table;
    flex-grow: 1;
    overflow-y: scroll;
  }
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) =>
      theme.skin === "fun"
        ? "var(--thumbBG)"
        : theme.skin === "pub"
          ? "#9A875D"
          : theme.skin === "cac" || theme.skin === "hyc"
            ? "#AAA2A5"
            : "var(--footerTextColor)"};
    border-radius: 5px;
    border: 0px solid var(--scrollbarBG);
  }
  table {
    table-layout: fixed;
    //margin: 0 30px;
    width: 100%;
    tr {
      height: 60px;
      //line-height: 60px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.13);
      th {
        font-size: 0.7rem;
        color: #fff;

        font-weight: 600;
        .flag {
          margin-left: 10px;
        }
        a {
          text-align: center;
          text-decoration: none;
          color: #fff;
        }
        &.win {
          font-weight: 800;
          text-align: right;
          padding-right: 10px;
        }
        &:nth-child(1) {
          text-align: left;
        }
        &:nth-child(3) {
          width: 25%;
          text-align: center;
          font-weight: 900;
        }
        &:nth-child(2) {
          text-align: center;
        }
      }
    }
  }
`;

export const SidePanelOverley = styled.div`
  ${(props) => {
    if (props.theme.current === "dark") {
      return `
          content: ' ';
          position: absolute;
          left: 0;
          right: 0;
          height: 120px;
          bottom: 100px;
          /* background: linear-gradient(
            rgba(0, 0, 0, 0),
            rgba(0, 0, 0, 0.4),
            rgba(0, 0, 0, 0.8),
            rgba(0, 0, 0, 1)
          ); */
          z-index: 1;
      `;
    } else {
      return `
      /* background: linear-gradient(
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0.4),
        rgba(255, 255, 255, 0.8),
        rgba(255, 255, 255, 1) */
      )`;
    }
  }}
`;

export const SidePanelBottom = styled.div.attrs({
  className: "mt-auto",
})`
  cursor: pointer;
  color: #fff;
  height: 100px;
  align-items: center;
`;

export const SidePanelRegister = styled.div`
  padding-top: 30px;
  color: ${({ theme }) => theme.skin === "abc" && "#0554B3"};
  a {
    color: #fff;
    float: right;
  }
`;

export const TournamentInfoDiv = styled.div.attrs({
  className: "text-center text-uppercase pt-3",
})`
  font-size: 0.8rem;
`;

export const GridyGameWrapper = styled.div.attrs({
  className: "griddy grid-container-opened",
})``;

export const SidePanelSearchWrapper = styled.div`
  width: 100%;
  min-height: 50px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-top: ${({ theme }) => (theme.skin === "cac" ? "10px" : "30px")};

  input {
    border: ${({ theme }) =>
      (theme.skin === "cac" || theme.skin === "hyc") && "none !important"};
  }
  .icon {
    margin: 0;
  }
  .list-group {
    a {
      height: 50px !important;
    }
  }

  div {
    z-index: 1;
    width: 100%;
    height: 100%;
    padding: 0;
    overflow-x: hidden;
  }
  label {
    width: 100%;
    background-color: transparent !important;
  }
  input.form-control {
    height: 40px !important;
    background-color: transparent !important;
    border-radius: ${({ theme }) =>
      theme.skin === "cac" || theme.skin === "hyc" ? "30px" : "0 !important"};
    padding: ${({ theme }) =>
      theme.skin === "cac" || theme.skin === "hyc" ? "5px" : "0 !important"};
  }
  input[type="text"] {
    color: #fff !important;
  }
  #search-no-results {
    height: 45px;
    text-align: center;
    padding: 10px;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-text-fill-color: #fff !important;
    -webkit-box-shadow: 0 0 0px 1000px transparent inset;
    box-shadow: 0 0 0px 1000px transparent inset;
    transition: background-color 5000s ease-in-out 0s;
    border-bottom: 1px solid #fff !important;
  }
  input[type="text"]::selection {
    background-color: var(--bgcolor);
  }
`;

export const IFrame = styled.iframe`
  ${(props) => {
    if (props.fullscreen) {
      return `
      object-fit: contain;
      position: fixed !important;
      top: 0px !important;
      right: 0px !important;
      bottom: 0px !important;
      left: 0px !important;
      box-sizing: border-box !important;
      min-width: 0px !important;
      max-width: none !important;
      min-height: 0px !important;
      max-height: none !important;
      width: 100% !important;
      height: 100% !important;
      transform: none !important;
      margin: 0px !important;
`;
    }
  }}
  filter: ${({ loggedout }) => loggedout === true && "blur(0.4rem)"};
  pointer-events: ${({ loggedout }) => loggedout === true && "none"};
`;

export const CarouselProviderWrapper = styled.div`
  width: 150px;
  height: 100px;
  text-align: center;
  border-radius: ${({ theme }) => (theme.skin === "fun" ? "20px" : "0.5rem")};
  margin: 0 auto;
  background-color: ${({ theme, themes }) =>
    themes
      ? ""
      : theme.skin === "yet" ||
          theme.skin === "fun" ||
          theme.skin === "cac" ||
          theme.skin === "hyc"
        ? "var(--bgColorABC)"
        : theme.skin === "pub"
          ? "#1D1D1D"
          : "var(--playLive)"};
  /* background-color: red; */

  img {
    padding: 20px;
    width: 150px;
    height: 100px;
    margin: 0 auto;
  }
  &:hover {
    transform: scale(1.1);
    -webkit-transform: scale(1.1); /* Safari & Chrome */
    -moz-transform: scale(1.1); /* Firefox */
    -ms-transform: scale(1.1); /* Internet Explorer */
    -o-transform: scale(1.1);
    transition: transform 0.2s;
    -webkit-transition: transform 0.2s;
    -moz-transition: transform 0.2s; /* Firefox */
    -ms-transition: transform 0.2s; /* Internet Explorer */
    -o-transition: transform 0.2s;
    cursor: pointer;
  }
  @media (max-width: 767px) {
    width: 110px;
    height: 65px;
    img {
      width: 110px;
      height: 65px;
      padding: 10px;
    }
  }
`;

export const StyledMaterialGrossIcon = styled.span`
  &:after {
    margin-left: 7px;
    font-family: "Material Icons";
    content: "swap_vert";
    vertical-align: bottom;
  }
`;
export const StyledMaterialTimelapseIcon = styled.span`
  &:after {
    margin-left: 7px;
    font-family: "Material Icons";
    content: "timelapse";
    vertical-align: bottom;
  }
`;
export const StyledMaterialScheduleIcon = styled.span`
  &:after {
    margin-left: 7px;
    font-family: "Material Icons";
    content: "schedule";
    vertical-align: bottom;
  }
`;

export const GameSessionStatsContainer = styled.div.attrs({
  className: "d-flex justify-content-between",
})`
  background-color: black;
  color: white;
  padding: 0 10px;
  font-size: 0.8rem;
`;

export const AlignCategoryTitle = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`;

/* export const SportsBookWrapper = styled.div.attrs((props) => ({
  className:
    props.theme.skin === "abc" ? "pb-5" : "mb-5",
}))`
  background-color: ${({ theme }) =>
    theme.skin === "abc"
      ? "var(--mainDescriptionABC)"
      : "var(--lobbybg)"};
`;

export const SportsBookCategoriesWrapper = styled.div`
  padding: ${isMobile ? "0" : "40px"};
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) =>
    theme.skin === "abc"
      ? "var(--mainDescriptionABC)"
      : "var(--lobbybg)"};
  & > div {
    width: ${({ theme }) =>
      theme.skin === "pub" && isMobile ? "" : "1600px"};
    height: auto;
    max-width: 100%;

    @media (max-width: 768px) {
      padding: ${isMobile ? "0px 20px 0 20px" : "10px 20px 0 20px"};
    }
`; */

export const DepositInGameWrapper = styled.button`
  background-color: rgba(0, 0, 0, 0.5);
  padding: 2px 15px;
  border-radius: 0px 10px 10px 0;
  background-color: var(--inGameDepositButtonBg);
  color: ${({ theme }) =>
    theme.skin !== "cac" && theme.skin !== "hyc" && "#fff"};
  font-weight: ${({ theme }) =>
    theme.skin === "fun" || theme.skin === "pub" ? "500" : "600"};
  font-size: ${({ theme }) =>
    theme.skin !== "cac" &&
    theme.skin !== "hyc" &&
    theme.skin !== "pub" &&
    "1rem"};
  text-transform: capitalize;
  border: none;
`;

export const DepositInGameBox = styled.div.attrs({
  id: "box-deposit",
})`
  left: ${({ show }) => (show ? "0px" : "-71px")};
  display: flex;
  flex-direction: column;
  z-index: 1003;
  top: 0;
  transform: translateX(0px) translateY(80svh) translateZ(0px);
  justify-content: space-around;
  align-items: center;
  position: fixed;
  transition-property: left;
  transition-duration: 300ms;
  transition-delay: 300ms;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 0px 10px 10px 0;

  img {
    height: 20px;
    padding: 2px 0;
  }
`;

export const CategorySearchWrapper = styled.div`
  margin-bottom: 0.5rem;
  input {
    width: 100%;
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
    color: var(--scrollbarBG);
    border: none;
    font-weight: bold;
    background-image: linear-gradient(
      to right bottom,
      rgb(254, 251, 0),
      rgb(231, 176, 0)
    );
  }
`;

export const LobbyTitle = styled.h3`
  /* text-align: left;
  max-width: 150px;
  position: relative;
  top: -30px; */
  text-transform: uppercase;
`;

export const LobbyNavgationTop = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 3rem 2rem 0 2rem;
  div {
    text-align: right;
    display: flex;
  }
  /* align-items: center; */
`;

export const LobbyNavigationWrapper = styled.div`
  width: 100%;
  /* height: 45px; */
  position: relative;
  display: flex;
  max-width: 1600px;
  top: ${isMobile && "-55px"};
  padding: ${isMobile ? "1rem 0" : "2rem"};

  p {
    border: 1px solid #979797;
    padding: 0.5rem 2rem;
    border-radius: 1.5rem;
    margin-bottom: 0;
  }

  a {
    margin: auto;
  }
  div {
    &:first-child {
      width: 50%;
      position: ${isMobile && "absolute"};
      margin-top: ${isMobile && "-55px"};
    }
  }
  select {
    width: ${!isMobile ? "" : "100%"};
    height: 100%;
    border-right: 16px solid transparent;
  }
`;

export const LogoutInfoText = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: ${({ sidepanel }) => (sidepanel ? "calc(100% - 320px)" : "100%")};
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
  color: white;
  font-size: 24px;
  font-weight: bold;

  div {
    text-align: center;
    padding: ${({ theme }) => theme.skin === "pub" && "1rem"};
    background-color: ${({ theme }) => theme.skin === "pub" && "#12100c"};
    max-width: 500px;
  }
  button {
    margin: 0.5rem;
    min-width: 80px;
  }
`;

// Game description from BO (HTML from an editor: h1-h3, p, a, table)
export const GameDescriptionWrapper = styled.div`
  color: #fff;
  font-size: 1rem;
  line-height: 1.6;
  text-align: left;
  max-width: 960px;
  margin: 0 auto;
  padding: 2rem 1rem 3rem;

  h1,
  h2,
  h3 {
    text-align: left;
    line-height: 1.25;
    margin: 2rem 0 0.75rem;
  }
  h1 {
    font-size: 2rem;
    margin-top: 0;
  }
  h2 {
    font-size: 1.5rem;
  }
  h3 {
    font-size: 1.15rem;
    margin-top: 1.5rem;
  }
  p {
    margin: 0 0 1rem;
  }
  a {
    color: inherit;
    text-decoration: underline;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    margin: 0 0 1.5rem;
  }
  th,
  td {
    text-align: left;
    vertical-align: top;
    padding: 0.6rem 0.75rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  }
  th {
    font-weight: 700;
    border-bottom-color: rgba(255, 255, 255, 0.35);
  }
  td:first-child {
    width: 30%;
    font-weight: 600;
  }
  th p,
  td p {
    margin: 0;
  }
  /* the BO editor wraps every cell in <span style="font-weight: 400"> */
  th span,
  td:first-child span {
    font-weight: inherit !important;
  }
`;
